import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { openVipModal } from "@/lib/vipModal";

/**
 * The public /register page is disabled — memberships launch Summer.
 * We bounce visitors back to the landing page and pop the VIP lead-capture
 * modal so we still capture interest.
 *
 * Direct admin login is still possible via /login (no longer linked from UI).
 */
export default function Register() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/", { replace: true });
    // Slight delay so the landing page mounts before the modal opens.
    const t = setTimeout(() => openVipModal("interested", "register-redirect"), 250);
    return () => clearTimeout(t);
  }, [navigate]);
  return null;
}
